import React, {useEffect, useState} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import Config from "../../core/config";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";
import ConfirmButton from "../common/ConfirmButton";
import BackButton from "../common/BackButton";
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";
import {findWalkInCustomers} from "../../utils/requestUtils";
import {formatPhoneNumber} from "../../core/telephone";

const apiUrl = Config.apiUrl;

function onlyDigits(str) {
    return (str || '').replace(/\D/g, '');
}

function formatZipCode(value) {
    const digits = onlyDigits(value).slice(0, 8);
    if (digits.length > 5) {
        return digits.slice(0, 5) + '-' + digits.slice(5);
    }
    return digits;
}

// Cadastro dos clientes de Take Away/Delivery: os mesmos que esses pedidos criam e buscam pelo telefone.
const WalkInCustomerManager = () => {
    const [, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get('id');

    const newEntity = {
        id: undefined,
        name: '',
        phone: '',
        walkIn: true,
        enabled: true,
        deliveryZipCode: '',
        deliveryStreet: '',
        deliveryNumber: '',
        deliveryComplement: '',
        deliveryReference: '',
        deliveryNeighborhood: '',
    };

    const [formData, setFormData] = useState(newEntity);

    useEffect(() => {
        async function makeQuery() {
            if (!id) {
                setFormData(newEntity);
                return;
            }
            try {
                const url = apiUrl + '/api/customers/id=' + id;
                const response = await makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')});
                setFormData({...newEntity, ...response});
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }

        makeQuery();
    }, [id]);

    const setField = (name, value) => {
        setFormData((prevData) => ({...prevData, [name]: value}));
    };

    const handleZipCodeChange = async (e) => {
        const formatted = formatZipCode(e.target.value);
        setField('deliveryZipCode', formatted);

        const digits = onlyDigits(formatted);
        if (digits.length === 8) {
            try {
                setLoading(true);
                const response = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
                const data = await response.json();
                if (!data.erro) {
                    setField('deliveryStreet', data.logradouro ? data.logradouro.toUpperCase() : '');
                    setField('deliveryNeighborhood', data.bairro ? data.bairro.toUpperCase() : '');
                }
            } catch (error) {
                console.error('Error fetching CEP:', error);
            } finally {
                setLoading(false);
            }
        }
    };

    async function validateInputs() {
        if (!formData.name || formData.name.trim() === '') {
            alert('Preencha o campo nome.');
            return false;
        }
        const phone = onlyDigits(formData.phone);
        if (phone.length < 10) {
            alert('Informe um telefone válido, com DDD.');
            return false;
        }
        const zipCodeDigits = onlyDigits(formData.deliveryZipCode);
        if (zipCodeDigits.length > 0 && zipCodeDigits.length !== 8) {
            alert('Informe um CEP válido.');
            return false;
        }
        // Take Away/Delivery acham o cliente pelo telefone, então ele não pode se repetir.
        const customers = (await findWalkInCustomers()) || [];
        const duplicated = customers.find((c) => onlyDigits(c.phone) === phone && String(c.id) !== String(formData.id));
        if (duplicated) {
            alert('Já existe um cliente com esse telefone: ' + duplicated.name + '.');
            return false;
        }
        return true;
    }

    const onConfirm = async () => {
        try {
            setLoading(true);
            if (await validateInputs()) {
                const url = apiUrl + '/api/customers';
                await makeRequest(url, formData.id ? 'PUT' : 'POST', {
                    'Content-Type': 'application/json',
                    'Useruuid': Cookies.get('userUUID'),
                }, JSON.stringify({
                    ...formData,
                    name: formData.name.trim().toUpperCase(),
                    phone: onlyDigits(formData.phone),
                    walkIn: true,
                }));
                navigate('/walkin-customerlist');
            }
        } catch (error) {
            console.error('Error saving:', error);
            alert('Error ao salvar.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <div className="header-label">{formData.id > 0 ? 'Editar' : 'Cadastrar'} Cliente</div>

            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Nome:</div>
                <input type="text" style={{width: '300px'}} value={formData.name}
                       onChange={(e) => setField('name', e.target.value.toUpperCase())}/>
            </div>
            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Telefone:</div>
                <input type="text" style={{width: '200px'}} value={formatPhoneNumber(formData.phone || '')}
                       onChange={(e) => setField('phone', onlyDigits(e.target.value).slice(0, 11))}
                       inputMode="numeric"/>
            </div>
            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>CEP (opcional):</div>
                <input type="text" style={{width: '150px'}} value={formData.deliveryZipCode || ''}
                       onChange={handleZipCodeChange} inputMode="numeric"/>
            </div>
            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Rua:</div>
                <input type="text" style={{width: '300px'}} value={formData.deliveryStreet || ''}
                       onChange={(e) => setField('deliveryStreet', e.target.value.toUpperCase())}/>
            </div>
            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Número:</div>
                <input type="text" style={{width: '120px'}} value={formData.deliveryNumber || ''}
                       onChange={(e) => setField('deliveryNumber', e.target.value)}/>
            </div>
            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Complemento:</div>
                <input type="text" style={{width: '300px'}} value={formData.deliveryComplement || ''}
                       onChange={(e) => setField('deliveryComplement', e.target.value.toUpperCase())}/>
            </div>
            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Ponto de Referência:</div>
                <input type="text" style={{width: '300px'}} value={formData.deliveryReference || ''}
                       onChange={(e) => setField('deliveryReference', e.target.value.toUpperCase())}/>
            </div>
            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Bairro:</div>
                <input type="text" style={{width: '300px'}} value={formData.deliveryNeighborhood || ''}
                       onChange={(e) => setField('deliveryNeighborhood', e.target.value.toUpperCase())}/>
            </div>
            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Habilitado:</div>
                <input type="checkbox" checked={formData.enabled !== false}
                       onChange={(e) => setField('enabled', e.target.checked)}/>
            </div>

            <ActionButtonsManagerView>
                <BackButton onClick={() => navigate(-1)}/>
                <ConfirmButton onClick={onConfirm}/>
            </ActionButtonsManagerView>
        </div>
    );
};

export default WalkInCustomerManager;
